import { render, staticRenderFns } from "./RewardTerm.vue?vue&type=template&id=7281781e&scoped=true&"
import script from "./RewardTerm.vue?vue&type=script&lang=js&"
export * from "./RewardTerm.vue?vue&type=script&lang=js&"
import style0 from "./RewardTerm.vue?vue&type=style&index=0&id=7281781e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281781e",
  null
  
)

export default component.exports